import { BaseModel } from "@/models/base.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import type { Moment } from "moment"
import type { IWorkPeriod } from "@/interfaces/api/work-period.interface.ts"
import { Activity } from "@/models/activity.model.ts"

export class WorkPeriod extends BaseModel implements IWorkPeriod {
  public static className = "WorkPeriod" // Used for socket communication.
  public static verboseName = "dienst"

  public static override managedResolveFields = ["owner"]

  owner: KnownBusinessEntityContact
  activities: Activity[]

  timeStart: Moment
  timeEnd?: Moment | null
  description?: string

  constructor(workPeriod: IWorkPeriod, managed = false) {
    super(workPeriod)

    this.owner = ModelFactory.childModel(KnownBusinessEntityContact, workPeriod.owner, managed)
    this.activities = ModelFactory.childModels(Activity, workPeriod.activities, managed)

    this.timeStart = workPeriod.timeStart
    this.timeEnd = workPeriod.timeEnd
    this.description = workPeriod.description
  }
}
